import { useMutation, useQueryClient } from '@tanstack/react-query';

import { actionItemKey } from '@services/actionItem/useActionItemQuery';
import { actionItemsGlobalOrIdListKey } from '@services/actionItem/useActionItemsGlobalOrIdListQuery';
import { apiClient } from '@services/apiClient';

import { actionItemCommentsKey } from './useActionItemCommentsQuery';

const updateOrDeleteWorkOrderFn = (data: { wo_number: string }) =>
  apiClient.post(`${APP_API_URL}${data.wo_number ? 'update-work-order' : 'delete-work-order'}`, data);

export const useUpdateOrDeleteWorkOrderMutation = ({ actionItemId }: { actionItemId: string | number }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { action_item_id: string | number; wo_number: string }) =>
      updateOrDeleteWorkOrderFn(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [actionItemsGlobalOrIdListKey()[0]] });
      queryClient.invalidateQueries({ queryKey: actionItemKey(actionItemId) });
      queryClient.invalidateQueries({ queryKey: actionItemCommentsKey(actionItemId) });
    },
  });
};
